<div class="row bgSection" id="main">  
  <div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
      <div class="alert alert-danger mt-3 text-center">
      <a class="close link" data-dismiss="alert">×</a>
      {{errorMessage}}
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMsg">
      <div class="alert alert-success mt-3 text-center">
      <a class="close link" data-dismiss="alert">×</a>
      {{successMsg}}
      </div>
    </div>
  </div>
  <div class="col-sm-12">
    <div class="form_div">
      <div class="">
        <form [formGroup]="form" (ngSubmit)="submit(form.value)" class="pt-2">
          <div class="loginFormContainer">
            <div class="text-center" data-background-color="orange">
              <h2 class="mb-4 formHeading">Become A Design Partner</h2>
              <app-error-label [control]="form" [submitted]="submitted"></app-error-label>
            </div>
            <div class="">
              <div class="form-group">           
                  <input class="form-control" formControlName="name" type="text" name="name" placeholder="Name*">
                  <div class="alert error" *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                      Name is required
                  </div> 
                  <!-- <p *ngIf="showvalidNameMsg" class="text-danger">Name is required</p>    -->
              </div>
              <div class="form-group">                            
                  <input class="form-control" formControlName="contact" type="number" name="contact" placeholder="Mobile*">
                  <div class="alert error" *ngIf="!form.controls['contact'].valid && form.controls['contact'].touched">
                      Mobile is required
                  </div> 
                    <!-- <p *ngIf="showvalidMobileNoMsg" class="text-danger">Contact is required</p>                            -->
              </div>        
              <div class="form-group">                          
                  <input class="form-control" formControlName="email" type="email" name="email" placeholder="Email*">
                  <div class="alert error" *ngIf="!form.controls['email'].valid && form.controls['email'].touched">
                      Email is required
                  </div>    
                    <!-- <p *ngIf="showvalidEmailMsg" class="text-danger">Email is required</p>  -->
              </div>
              <div class="form-group">                            
                  <input class="form-control" formControlName="instagram_handle" type="text" name="instagram_handle" placeholder="Instagram Id">
              </div>        
              <div class="form-group">                          
                  <label for="cvUpload" class="form-control uploadText"><span id="fileName">Upload CV</span><span class="cvSpan"><i class="fa fa-upload" aria-hidden="true"></i></span></label>
                  <input type="file" id="cvUpload" style="display: none" (change)="uploadCV($event)">
              </div>
            </div>
            <button type="submit" class="button button_emi">SIGN UP</button>    
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/authentication/sign-up-designer/sign-up-designer.component.html